import i18n, { t } from "./index";

// Backend-generated text stored in the DB (ledger reasons, job errors, notifications, match explanations).
// Each pattern maps an English sentence to a catalog key with named parameters.
const label = (s) => t(String(s).replaceAll("_", " "));
const PATTERNS = [
  [/^(.*) \(charged (\d+), released (\d+)\)$/, "{{reason}} (charged {{charged}}, released {{released}})", (m) => ({ reason: tDynamic(m[1].trim()), charged: m[2], released: m[3] })],
  [/^Reserve ([a-z_]+)$/, "Reserve {{kind}}", (m) => ({ kind: label(m[1]) })],
  [/^Enrichment ([a-z_]+) — refunded$/, "Enrichment {{status}} — refunded", (m) => ({ status: label(m[1]) })],
  [/^([a-z_]+) (?:failed|interrupted|suppressed) — refunded$/, "{{kind}} failed — refunded", (m) => ({ kind: label(m[1]) })],
  [/^Discovery · (.+)$/, "Discovery · {{name}}", (m) => ({ name: m[1] })],
  [/^Located in (.+?); requested (.+?)(?: within (\d+) km)?( \(open to relocation\))?$/, "Located in {{loc}}; requested {{req}}", (m) => ({ loc: m[1], req: m[2] }),
    (m) => (m[3] ? (m[4] ? "Located in {{loc}}; requested {{req}} within {{km}} km (open to relocation)" : "Located in {{loc}}; requested {{req}} within {{km}} km") : m[4] ? "Located in {{loc}}; requested {{req}} (open to relocation)" : null), (m) => ({ km: m[3] })],
  [/^(.*) · (\d+) km from (.+)$/, "{{loc}} · {{km}} km from {{city}}", (m) => ({ loc: m[1], km: m[2], city: m[3] })],
  [/^within (\d+) km of (.+)$/, "within {{km}} km of {{city}}", (m) => ({ km: m[1], city: m[2] })],
  [/^(\d+) new profiles for “(.+)”$/, "{{count}} new profiles for “{{name}}”", (m) => ({ count: +m[1], name: m[2] })],
  [/^(.+) mentioned you$/, "{{name}} mentioned you", (m) => ({ name: m[1] })],
  [/^New reply from (.+)$/, "New reply from {{name}}", (m) => ({ name: m[1] })],
  [/^Relevant role — (.+)$/, "Relevant role — {{role}}", (m) => ({ role: m[1] })],
  [/^(\d+) years and (\d+) months$/, "{{y}} years and {{m}} months", (m) => ({ y: m[1], m: m[2] })],
  [/^(\d+) years$/, "{{count}} years", (m) => ({ count: +m[1] })],
  [/^(\d+) months$/, "{{count}} months", (m) => ({ count: +m[1] })],
  [/^(.+) – present$/, "{{from}} – present", (m) => ({ from: m[1] })],
];

export function tDynamic(text) {
  if (text == null || text === "") return "";
  const s = String(text).trim();
  if (i18n.exists(s)) return t(s);
  for (const [rx, key, params, pickKey, extra] of PATTERNS) {
    const m = s.match(rx);
    if (m) return t((pickKey && pickKey(m)) || key, { ...params(m), ...(extra ? extra(m) : {}) });
  }
  return s;
}

export const DYNAMIC_KEYS = PATTERNS.flatMap((p) => [p[1]]).concat([
  "Located in {{loc}}; requested {{req}} within {{km}} km", "Located in {{loc}}; requested {{req}} within {{km}} km (open to relocation)",
  "Located in {{loc}}; requested {{req}} (open to relocation)"]);
